<template>
	<div>
            <!--notice + login-->
            <div class="notice-login clearfix">
                <div class="login fl">
                    <!-- login 修改后 -->
                    <h6>报名咨询</h6>
                    <div class="login-contact clearfix">
                        <img src="../../static/images/icon-phone-big.png"/>
                        <div class="login-contact-text">
                          <p>{{showImg == 2?'电话':'咨询热线'}}</p>
                          <p v-if="showImg == 1" class="red">{{ profile.telephone }}</p>
                          <p style="font-size: 18px;" v-if="showImg == 2" class="red">{{ profile.telephone }}<span style="margin-left: 5px;margin-right: 5px">/</span>0898-66769273</p>
                        </div>
                    </div>
                    <div class="login-contact clearfix">
                        <img src="../../static/images/icon-email-big.png"/>
                        <div class="login-contact-text">
                          <p>{{showImg == 1?'咨询':''}}邮箱</p>
                          <p class="red">{{ profile.email }}</p>
                        </div>
                    </div>
                    <div class="login-onlie" @click="showKefu()">{{showImg == 2?'在线客服':'咨询在线客服'}}</div>
                    <div class="login-check" @click="goOccupationList()">查询报考条件</div>
                    <!-- login 修改前 -->
                    <!-- <div class="login-tab-box clearfix">
                        <div class="login-tab fl" :class="{ on: signType == '0' }" @click="cutSignType('0')">考生登陆</div>
                        <div class="login-tab fr" :class="{ on: signType == '1' }" @click="cutSignType('1')">机构登陆</div>
                    </div>
                    <el-form :model="editForm" :rules="editRules" ref="editForm">
                        <div class="login-input-box" v-if="signType == '0'">
                            <el-form-item label="" prop="name">
                                <el-input v-model.trim="editForm.name" placeholder="姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="idno">
                                <el-input type="password" v-model.trim="editForm.idno" placeholder="身份证号"></el-input>
                            </el-form-item>
                        </div>
                        <div class="login-input-box" v-else>
                            <el-form-item label="" prop="userName">
                                <el-input v-model.trim="editForm.userName" placeholder="用户名"></el-input>
                            </el-form-item>
                            <el-form-item label="" prop="password">
                                <el-input type="password" v-model.trim="editForm.password" placeholder="密码"></el-input>
                            </el-form-item>
                        </div>
                        <div class="login-img clearfix">
                            <el-form-item label="" prop="captImg">
                                <el-input v-model.trim="editForm.captImg" placeholder="验证码"></el-input>
                            </el-form-item>
                            <img class="fl" @click="refreshCode()" :src="yzmurl" />
                            <a class="fl" href="javascript:void(0)" @click="refreshCode()">换一张</a>
                        </div>
                    </el-form> -->
                    <!-- <a class="forget-psd" target="_blank" v-if="signType == '1'" @click="goForgetPassword()">忘记密码？</a> -->
                    <!-- <div class="login-btn-box clearfix">
                        <div class="login-btn fl" @click="signIn()">登&nbsp;&nbsp;录</div>
                        <a class="login-btn login-btn-regist fr" target="_blank" @click="goRegister()">注&nbsp;&nbsp;册</a>
                    </div> -->
                </div>
                <div class="notice fr">
                    <div class="index-title clearfix">
                        <div class="index-title-line fl"></div>
                        <h4 class="fl">通知公告</h4>
                        <a class="fr" href="javascript:void(0)" @click="goList('notice')">更多>></a>
                    </div>
                    <div class="notice-box">
                        <a class="notice-slide clearfix" href="javascript:void(0)" v-for="(item, index) in noticeList" :key="index" @click="goDetails(item.id, 'notice')">
                            <h6 class="fl">{{ item.title }}</h6>
                            <span class="fr">{{ item.createTime | formatDate1 }}</span>
                        </a>
                    </div>


                </div>

            </div>

            <!--occupation-->
            <div class="occupation">
                <div class="index-title clearfix">
                    <div class="index-title-line fl"></div>
                    <h4 class="fl">职业工种</h4>
                    <a class="fr" href="javascript:void(0)" @click="goOccupationList()">更多>></a>
                </div>
                <div class="occupation-box clearfix">
                    <a href="javascript:void(0)" class="occupation-slide fl" v-for="(item, index) in occupationList" :key='index' @click="goOccupationDetails(item.id)">
                        <div class="occupation-img" :style="{backgroundImage:'url(' + item.coverUrl + ')'}">
                            <img :src="item.coverUrl" :alt="item.jobName"/>
                        </div>
                        <h6>{{ item.jobName }}</h6>
                    </a>

                </div>
            </div>

            <!--recruit + policy-->
            <div class="recruit-policy clearfix">

                <div class="rec-pol recruit fl">
                    <div class="index-title clearfix">
                        <div class="index-title-line fl"></div>
                        <h4 class="fl">人才服务</h4>
                        <a class="fr" href="javascript:void(0)" @click="goList('recruit')">更多>></a>
                    </div>
                    <div class="rec-pol-box">
                        <a class="rec-pol-slide clearfix" v-for="(item, index) in recruitList" :key="index" @click="goDetails(item.id, 'recruit')">
                            <h6 class="fl">{{ item.title }}</h6>
                            <span class="fr">{{ item.createTime | formatDate1 }}</span>
                        </a>
                    </div>
                </div>

                <div class="rec-pol policy fr">
                    <div class="index-title clearfix">
                        <div class="index-title-line fl"></div>
                        <h4 class="fl">政策法规</h4>
                        <a class="fr" href="javascript:void(0)" @click="goList('policy')">更多>></a>
                    </div>
                    <div class="rec-pol-box">
                        <a class="rec-pol-slide clearfix" v-for="(item, index) in policyList" :key="index" @click="goDetails(item.id, 'policy')">
                            <h6 class="fl">{{ item.title }}</h6>
                            <span class="fr">{{ item.createTime | formatDate1 }}</span>
                        </a>
                    </div>
                </div>

            </div>

            <!--department-->
            <div class="department">
                <div class="index-title clearfix">
                    <div class="index-title-line fl"></div>
                    <h4 class="fl">主管部门</h4>
                    <!--<a class="fr" href="javascript:void(0)">更多>></a>-->
                </div>
                <div class="department-box clearfix">

                    <a target="_blank" href="http://www.mohrss.gov.cn/" class="department-slide fl" style="background-image: url(/static/images/department1.jpg);">
                        <img src="/static/images/department1.jpg" alt="中华人民共和国人力资源和社会保障部"/>
                    </a>
                    <template v-if="showImg == 1">
                      <a target="_blank" href="http://rst.sc.gov.cn/" class="department-slide fl" style="background-image: url(/static/images/department2.jpg);">
                        <img src="/static/images/department1.jpg" alt="四川省人力资源和社会保障厅"/>
                      </a>
                    </template>
                    <template v-if="showImg == 2">
                      <a target="_blank" href="http://hrss.hainan.gov.cn/" class="department-slide fl" style="background-image: url(/static/images/hainanrlzy.jpg);">
                        <img src="/static/images/department1.jpg" alt="海南省人力资源和社会保障厅"/>
                      </a>
                    </template>


                    <a target="_blank" href="http://chinajob.mohrss.gov.cn/" class="department-slide fl" style="background-image: url(/static/images/department3.jpg);">
                        <img src="/static/images/department1.jpg" alt="中国就业培训技术指导中心(中国就业网)"/>
                    </a>
                </div>
            </div>

    </div>
</template>
<style scoped>
.login-input-box .el-form-item{
    margin-bottom: 26px;
}
.login-img .el-form-item{
    width: 130px;
    float: left;
    margin-right: 14px;
    margin-bottom: 0;
}
</style>
<style src="../../static/css/studentindex.css" scoped></style>
<script>
import md5 from "js-md5";
export default {
    name: "stuIndex",
	data: function () {
        //身份证验证
        var checkIdentitytionId = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("身份证号不能为空"));
            }
            if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                callback(new Error("你输入的身份证长度或格式错误"));
            }
            //身份证城市
            var aCity = {
                11: "北京",
                12: "天津",
                13: "河北",
                14: "山西",
                15: "内蒙古",
                21: "辽宁",
                22: "吉林",
                23: "黑龙江",
                31: "上海",
                32: "江苏",
                33: "浙江",
                34: "安徽",
                35: "福建",
                36: "江西",
                37: "山东",
                41: "河南",
                42: "湖北",
                43: "湖南",
                44: "广东",
                45: "广西",
                46: "海南",
                50: "重庆",
                51: "四川",
                52: "贵州",
                53: "云南",
                54: "西藏",
                61: "陕西",
                62: "甘肃",
                63: "青海",
                64: "宁夏",
                65: "新疆",
                71: "台湾",
                81: "香港",
                82: "澳门",
                91: "国外"
            };
            if (!aCity[parseInt(value.substr(0, 2))]) {
                callback(new Error("你的身份证地区非法"));
            }
            // 出生日期验证
            var sBirthday = (
                value.substr(6, 4) +
                "-" +
                Number(value.substr(10, 2)) +
                "-" +
                Number(value.substr(12, 2))
                ).replace(/-/g, "/"),
                d = new Date(sBirthday);
            if (
                sBirthday !=
                d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
            ) {
                callback(new Error("身份证上的出生日期非法"));
            }

            // 身份证号码校验
            var sum = 0,
                weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                codes = "10X98765432";
            for (var i = 0; i < value.length - 1; i++) {
                sum += value[i] * weights[i];
            }
            var last = codes[sum % 11]; //计算出来的最后一位身份证号码
            if (value[value.length - 1] != last) {
                callback(new Error("你输入的身份证号非法"));
            }
            callback();
        };
		return {
            editRules: {
                name: [{required: true, message: "姓名不能为空", trigger: "blur",}],
                idno: [{required: true, validator: checkIdentitytionId, trigger: "blur"}],
                userName: [{required: true, message: "用户名不能为空", trigger: "blur",}],
                password:[{required: true, message: "密码不能为空", trigger: "blur",}],
                captImg:[{required: true, message: "验证码不能为空", trigger: "blur",}],
            },
            editForm:{
                name:'',//学员姓名
                idno:'',//学员身份证号
                userName:'',//用户名
                password:'',//密码
                captImg:'',//验证码
            },
            signType:'0',//登录类型，0为学员登录，1为机构登录
            yzmurl:'',//验证码地址

            //文章数据
            noticeList:[],//通知公告
            policyList:[],//政策法规
            recruitList:[],//人才服务
            occupationList:[],//职业工种
            showImg: 1,
            profile: {},

		};
	},
	methods: {
        //点击展开客服
        showKefu(){
            $('#udesk_btn_text').trigger('click');
        },
        //组装udsk在线客服
        buildUdsk(a, h, c, b, f, g){
            a["UdeskApiObject"] = f;
            a[f] = a[f] || function() {
                (a[f].d = a[f].d || []).push(arguments)
            };
            g = h.createElement(c);
            g.async = 1;
            g.charset = "utf-8";
            g.src = b;
            c = h.getElementsByTagName(c)[0];
            c.parentNode.insertBefore(g, c)
        },
        //刷新图片验证码
        refreshCode(){
			var timenow = new Date().getTime();
			this.yzmurl = process.env.API_URL + "servlet/Image.Servlet?d=" + timenow;
		},
        //切换登录方式
        cutSignType(type){
            this.signType = type;
        },
        //登录
        signIn(){
            this.$refs.editForm.validate((valid) => {
                if(valid){
                    if(this.signType == '0'){//学员登录
                        let params = {};
                        params.studentName = this.editForm.name;
                        params.idcard = this.editForm.idno;
                        params.captcha = this.editForm.captImg;
                        this.$api.post("/api/studentInfo/valid", params, (res) => {
                            if (res.status == 0) {
                                window.localStorage.setItem("studentname", this.editForm.name);
                                this.$router.push({ path: "/stupersonal", query: { signType: this.signType } });
                            } else {
                                this.$message.error({ message: res.message });
                            }
                        });

                    }else{//机构登录
                        let param = {};
                        param.username = this.editForm.userName;
                        param.password = this.editForm.password;
                        param.captcha = this.editForm.captImg;
                        this.$api.post("/api/adminInfo/valid", param, (res) => {
                            if (res.status == 0) {
                                window.localStorage.setItem("organizationname", this.editForm.userName);
                                this.$router.push({ path: "/stupersonal", query: { signType: this.signType } });
                            } else {
                                this.$message.error({ message: res.message });
                            }
                        });
                    }
                }
            })
        },
        //跳转注册页
        goRegister(){
            this.$router.push({ path: "/register", query: { 'signType':this.signType }});
        },
        //跳转找回密码页
        // goForgetPassword(){
        //     this.$router.push({ path: "/forgetpassword", query: { 'signType':this.signType }});
        // },
        //获取通知公告
        getNoticeList(){
            let params = {};
            params.secCategaryName = '';
            params.categaryId = '2';//1为政策法规，2为通知公告，3为人才服务
            params.rows = 9;
            params.page = 1;
            this.$api.get("/api/centerCategarySec/list", params, (res) => {
                if (res.status == 0) {
                    this.noticeList = res.data.rows;
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        //获取政策法规
        getPolicyList(){
            let params = {};
            params.secCategaryName = '';
            params.categaryId = '1';//1为政策法规，2为通知公告，3为人才服务
            params.rows = 6;
            params.page = 1;
            this.$api.get("/api/centerCategarySec/list", params, (res) => {
                if (res.status == 0) {
                    this.policyList = res.data.rows;
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        //获取人才服务
        getRecruitList(){
            let params = {};
            params.secCategaryName = '';
            params.categaryId = '3';//1为政策法规，2为通知公告，3为人才服务
            params.rows = 6;
            params.page = 1;
            this.$api.get("/api/centerCategarySec/list", params, (res) => {
                if (res.status == 0) {
                    this.recruitList = res.data.rows;
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        //去政策、公告、人才服务列表,module,用于判别去哪个模块
        goList(category){
            if(category == 'notice'){//跳转通知公告
                this.$router.push({ path: "/stunotice" });
            }else if(category == 'policy'){//跳转政策法规
                this.$router.push({ path: "/stupolicy" });
            }else{//跳转人才服务
                this.$router.push({ path: "/sturecruit" });
            }
        },
        //去政策、公告、人才w详情
        goDetails(id, category){
            if(category == 'notice'){//跳转通知公告
                this.$router.push({ path: "/stunoticedetails", query: { 'id':id } });
            }else if(category == 'policy'){//跳转政策法规
                this.$router.push({ path: "/stupolicydetails", query: { 'id':id } });
            }else{//跳转人才服务
                this.$router.push({ path: "/sturecruitdetails", query: { 'id':id } });
            }
        },
        //获取职业工种列表
        getOccupationList(){
            let params = {};
            params.jobName = '';
            params.rows = 4;
            params.page = 1;
            this.$api.get("/api/jobIntroduction/list", params, (res) => {
                if (res.status == 0) {
                    this.occupationList = res.data.rows;
                }else{
                    this.$message.error(res.message);
                }
            })
        },
        //去职业工种列表
        goOccupationList(){
            this.$router.push({ path: "/stuoccupation"});
        },
        //去职业工种详情
        goOccupationDetails(id){
            this.$router.push({ path: "/stuoccupationdetails", query: { 'id':id } });
        },
        //获取中心简介
		getIntroduce(){
            this.$api.get("/api/centerDesc/list", '', (res) => {
                if (res.status == 0) {
                    if(res.data.length > 0){
                        this.profile = res.data[0];
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },
	},
    created(){
        //初始化验证码
        this.refreshCode();
        this.getIntroduce();
        //在线客服配置
        this.buildUdsk(window, document, "script", "https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js", 'ud');
        ud({
            "code": "2jhbcbc",
            "link": "https://clkefu.s4.udesk.cn/im_client/?web_plugin_id=4296"
        });
        document.write('<style>#udesk_btn{display: none;}</style>');
	},
    mounted() {
      var domain = window.location.hostname
      // 1四川2海南 hnjnrd.scjxjypx.com
      if (domain == "hnjnrd.scjxjypx.com") {
        this.showImg = 2
      }
        this.getNoticeList();
        this.getPolicyList();
        this.getRecruitList();
        this.getOccupationList();
	},
    filters: {
        formatDate1 (time) {
            if (time) {
                return time.slice(0, 10);
            } else {
                return;
            }
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/index.vue